'use es6';

import FallbackPublicPurchaseMotions from 'pricing-pages-lib/constants/FallbackPublicPurchaseMotions';
import { CUSTOMER_CURRENCY_CODE_RECEIVED } from 'pricing-pages-unified-ui/constants/ActionTypes';
import { createRequestTypes, createRequestActions } from './RequestActions';
export const FetchPurchaseMotionRequestTypes = createRequestTypes('PURCHASE_MOTION');
export const FetchPurchaseMotionActions = createRequestActions(FetchPurchaseMotionRequestTypes);
export const fetchPurchaseMotionData = ({
  getPurchaseMotions,
  isPublic = false
}) => {
  return dispatch => {
    dispatch(FetchPurchaseMotionActions.request());
    return getPurchaseMotions().then(data => {
      const {
        customerCurrencyCode,
        locations
      } = data;
      dispatch({
        type: CUSTOMER_CURRENCY_CODE_RECEIVED,
        payload: customerCurrencyCode,
        isPublic
      });
      dispatch(FetchPurchaseMotionActions.receive(locations));
    }).catch(error => {
      if (isPublic) {
        dispatch(FetchPurchaseMotionActions.receive(FallbackPublicPurchaseMotions));
      } else {
        dispatch(FetchPurchaseMotionActions.failure(error));
        throw error;
      }
    });
  };
};